import { EmailIntegrationProvider } from 'enums';

export const EmailIntegrationProviderMap: Record<EmailIntegrationProvider, string> = {
  [EmailIntegrationProvider.Google]: 'Google',
  [EmailIntegrationProvider.Imap]: 'IMAP',
  [EmailIntegrationProvider.Microsoft]: 'Microsoft',
  [EmailIntegrationProvider.Icloud]: 'iCloud',
  [EmailIntegrationProvider.VirtualCalendar]: 'Virtual Calendar',
};
